__turbopack_context__.v({
  "slide": "xFwWwG_slide",
});
